module.exports = __webpack_public_path__ + "static/media/Mini Project 23-24.03569cdf.pdf";